<template>
    <div class="test">
        <button @click="start">123</button>
        <div  class="btn" ref="btn" @click="start"></div>
    </div>

</template>

<script>
    // import axios from 'axios';

    export default {
        name: "Test",
        methods:{
            start(){
                // clearInterval(this.timer);

                // this.tranNumber(7500000)
                // console.log(this.tranNumber(7500000))
                // this.$refs.btn.style.left += 0.001;
                this.timer = setInterval( ()=> {
                    this.move();
                    console.log(123)
                },1000);
            },
            move(){
                this.$refs.btn.style.left += 10+'px';

            }

        }
    }


</script>

<style lang="stylus" rel="stylesheet/stylus">
    html,body
        width 100%
        height 100%
        margin 0
        padding 0
        .btn
            width 100px
            height 100px
            position relative
            top 0
            background: #000
            left 0

</style>
